/* CART TESTING */
     


/* CODE COPY */
$(".key-details .discount-code").click(function(event) {
    navigator.clipboard.writeText("NINNA10");
    document.cookie = "discount_code=NIINA10; expires=Thu, 18 Dec 2053 12:00:00 UTC ;domain=.kenkaliike.fi;path=/";
    $(".code-success").fadeIn(200).delay(2000).fadeOut(200);
});


/* PRODUCT TABS */
$("#shopify-section-template--23768607490427__f7cb9224-891b-4573-b168-f6a18493c253").css("display", "none");
$("#shopify-section-template--23768607490427__a9279e65-4a86-45db-a227-441fff79fb7e").css("display", "none");


$(".tab-1").click(function(event) {
  $(".tablinks ").removeClass("active");
  $(this).addClass("active");
  $("#shopify-section-template--23768607490427__e9318114-c1e5-4c51-9e3a-4bfb7850ecd4").css("display", "block");
  $("#shopify-section-template--23768607490427__f7cb9224-891b-4573-b168-f6a18493c253").css("display", "none");
  $("#shopify-section-template--23768607490427__a9279e65-4a86-45db-a227-441fff79fb7e").css("display", "none");
});

$(".tab-2").click(function(event) {
  $(".tablinks ").removeClass("active");
  $(this).addClass("active");
  $("#shopify-section-template--23768607490427__e9318114-c1e5-4c51-9e3a-4bfb7850ecd4").css("display", "none");
  $("#shopify-section-template--23768607490427__f7cb9224-891b-4573-b168-f6a18493c253").css("display", "block");
  $("#shopify-section-template--23768607490427__a9279e65-4a86-45db-a227-441fff79fb7e").css("display", "none");
});

$(".tab-3").click(function(event) {
  $(".tablinks ").removeClass("active");
  $(this).addClass("active");
  $("#shopify-section-template--23768607490427__e9318114-c1e5-4c51-9e3a-4bfb7850ecd4").css("display", "none");
  $("#shopify-section-template--23768607490427__f7cb9224-891b-4573-b168-f6a18493c253").css("display", "none");
  $("#shopify-section-template--23768607490427__a9279e65-4a86-45db-a227-441fff79fb7e").css("display", "block");
});


/* REVIEW GLANCE */
setTimeout(function(){ 
  var reviewText = ($('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__body").text().length > 150) ? $('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__body").text().substring(0, 150) + "..." : $('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__body").text();
  var reviewAuthor = $('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__author").text();

  
  if(reviewText != "" && reviewAuthor != ""){
    //console.log($('.jdgm-rev-widg__reviews .jdgm-rev').first().find(".jdgm-rev__author").text())
    $(".template-product .stars-review-glance .review-text").html("&quot;"+reviewText+"&quot;");
    $(".template-product .stars-review-glance .review-author").text(reviewAuthor);    
  }
  
}, 1000);

/* TOP MENU */
    $(".top-menu .navmenu-depth-1 li").hover(
  function () {
     $(this).find(".navmenu-depth-2").finish().slideDown('fast');
     $(this).find("details").attr("open", "open");
  }, 
  function () {
    $(this).find(".navmenu-depth-2").finish().slideUp('fast');
  }
);

/* COLOR OPTIONS IMAGE CHANGE */
$(window).on('load', function() {
      $(".color-boxes a img").on({
        mouseenter: function () {
          //console.log("IN");
          var hover_url = $(this).data("hover");
          $(this).parents(".productitem").find(".productitem--image-primary").attr('src', hover_url);
          $(this).parents(".productitem").find(".productitem--image-primary").attr('srcset', hover_url);
        },
        mouseleave: function () {
          //console.log("OUT");
          var normal_url = $(this).data("normal");
          $(this).parents(".productitem").find(".productitem--image-primary").attr('src', normal_url);
          $(this).parents(".productitem").find(".productitem--image-primary").attr('srcset', normal_url);
        }
    });
});


/* SALE PAGE */

function moveScroller() {
    var $anchor = $("#scroller-anchor");
    var $scroller = $('#scroller');

    var move = function() {
        var st = $(window).scrollTop();
        var ot = $anchor.offset().top;
        if(st > ot) {
            $scroller.css({
                position: "fixed",
                top: "0px"
            });
        } else {
            $scroller.css({
                position: "relative",
                top: ""
            });
        }
    };
    $(window).scroll(move);
    move();
}

$(document).on('click', '.template-page.sale .page-nav a[href^="#"]', function (event) {
    event.preventDefault();
    

    $( ".template-page.sale .page-nav a" ).each(function( index ) {
      $(this).parent().removeClass("active");
    });

    $(this).parent().addClass("active");
    //console.log($(this))
  
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 180
    }, 500);
});

$(window).on('scroll', e => {
  $('.productgrid--items').each(function() {
    if($(this).offset().top - 190 < $(window).scrollTop()) {
      let id = $(this).attr('id');
      //console.log(id);
      $('.template-page.sale .page-nav li').removeClass('active');
      $('#' + "link--" + id).addClass('active');
    }
  })
})

$('.template-page.sale .page-nav li').first().addClass('active');

/* READ MORE LINKS ON PRODUCT PAGE */
$(".product-text a").click(function(event) {
    event.preventDefault();
    //console.log("HERE");
    $('html, body').animate({
        scrollTop: parseInt($(".product-form--atc-button").offset().top) - 100
    }, 500);
    
  $(".collapsible-tab").first().attr("open", "");
});
   
  $(".collapsible-tab").first().attr("open", "");

/* STARS FILTER */
var stars_box = '<span class="needsclick stars-container stars-fivestar">★★★★★</span>';
$('.collection-filters__filter-group:contains("Arvostelut")').find(".collection-filters__filter-list-item-text").before(stars_box);


/* FILTER COLOR SWATCHES */
var color_swatch = "<span class='color-swatch'></span>";
$('.collection-filters__filter-group:contains("Väri")').find(".collection-filters__filter-list-item-text").before(color_swatch);

$( ".color-swatch" ).each(function( index ) {
  /* BLACK */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Musta")
  $(this).css("background","#000"); 

  /* RED */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Punainen") 
  $(this).css("background","#ff0000");

  /* BEIGE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Beige") 
  $(this).css("background","#F5F5DC");

  /* FUXIA PINK */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Fuxia") 
  $(this).css("background","#de5d72");

  /* GRAY */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Harmaa") 
  $(this).css("background","#999");

  /* SILVER */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Hopea") 
  $(this).css("background","#CCC");

  /* YELLOW */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Keltainen") 
  $(this).css("background","#ffcc00");

  /* GOLD */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Kulta") 
  $(this).css("background","#dcad48");

  /* MULTI */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Monivärinen") 
  $(this).css("background","linear-gradient(90deg, red, yellow, cyan, magenta)");

  /* NUDE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Nude") 
  $(this).css("background","#E3BC9A");

  /* OLIVE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Oliivi") 
  $(this).css("background","#808000");

  /* ORANGE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Oranssi") 
  $(this).css("background","#f2990d");

  /* BRONZE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Pronssi") 
  $(this).css("background","#917143");

  /* BROWN */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Ruskea") 
  $(this).css("background","#643e18");

  /* BLUE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Sininen") 
  $(this).css("background","#2187e7");

  /* TURQUOISE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Turkoosi") 
  $(this).css("background","#30D5C8");

  /* PINK */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Vaaleanpunainen") 
  $(this).css("background","#FF69B4");

  /* WHITE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Valkoinen") 
  $(this).css("background","#fff");

  /* GREEN */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Vihreä") 
  $(this).css("background","#2f8946");

  /* PURPLE */
  if($(this).parent().find(".collection-filters__filter-list-item-text").contents().get(0).nodeValue.trim() == "Violetti") 
  $(this).css("background","#8F00FF");
  
});

/* READ MORE - LESS */
 $(".read-more").click(function() {
        $(".full-desc").show(0);
        $(".short-desc").hide(0);
    });

 $(".read-less").click(function() {
        $(".full-desc").hide(0);
        $(".short-desc").show(0);
    });

/* FILTERS */
 $(".collection-filters__filter-group button").click(function() {
      
   $(this).parent().toggleClass("active");
    });

  $('.collection-filters__filter-group:contains("Koko")').addClass("active");
  
  /* PRICE FILTER 
  $('.collection-filters__filter-group:contains("Hinta")').addClass("active");
  var newFrom = parseInt($('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').first().val());
  var newTo = parseInt($('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').last().val());
  var newHolder = parseInt($('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').last().attr('placeholder'))
  $('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').first().val(newFrom);
  $('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').last().val(newTo);
  $('.collection-filters__filter-group:contains("Hinta") .collection-filters__filter-range-input').last().attr('placeholder', newHolder);
  */

/* KLUBI DASHBOARD */
if($(location).attr('pathname') == "/pages/oma-tili"){
      var myInterval = setInterval(function(){
       if($('#Avada-Joy_FloatingButton').length > 0) {
          $("#Avada-Joy_FloatingButton").detach().appendTo("#klubi-cont");
          
          clearInterval(myInterval);
       } 
       }, 100);

      $("#klubi-cont").click(function(event) {
        var hideInterval = setInterval(function(){
        //console.log("int");
         if($('li.Avada-Preview__NavItem:contains("Kanta asiakas -5%")').length > 0) {
            $('li.Avada-Preview__NavItem:contains("Kanta asiakas -5%")').hide();
           //console.log("DONE");
            clearInterval(hideInterval);
         } 
         }, 100);
        
        setTimeout(function(){ 
          clearInterval(hideInterval);
        }, 1000);
        
      });
}

/* COOKIES */
let searchParams = new URLSearchParams(window.location.search)
if(searchParams.has('klubi')){
  document.cookie = "discount_code=kanta-asiakas-5%; expires=Thu, 18 Dec 2053 12:00:00 UTC";
  document.cookie = "_klubi=1; expires=Thu, 18 Dec 2053 12:00:00 UTC";
}


function getCookie(k){var v=document.cookie.match('(^|;) ?'+k+'=([^;]*)(;|$)');return v?v[2]:null}

  if(getCookie("discount_code")){
    //console.log("NOT SETTING");
    //console.log(getCookie("discount_code"))
}
    
else{
  document.cookie = "discount_code=kanta-asiakas-5%; expires=Thu, 18 Dec 2053 12:00:00 UTC";
  document.cookie = "_klubi=1; expires=Thu, 18 Dec 2053 12:00:00 UTC";  
  console.log("SETTING");
}



/*
document.cookie = "discount_code=kanta-asiakas-5%; expires=Thu, 18 Dec 2053 12:00:00 UTC";
document.cookie = "_klubi=1; expires=Thu, 18 Dec 2053 12:00:00 UTC";
//document.cookie = 'discount_code' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
*/

/* FILTERS */
function modifyLink(link) {
    if (link.tagName !== 'A') return;

    const url = new URL(link.href);
    if (!url.searchParams.has("filter.v.availability")) {
        url.searchParams.append("filter.v.availability", "1");
        link.href = url.href;
    }
}

function setAvailabilityFilterInCollectionLinks() {
    const selectorStr = "a[href*='/collections/']"; // you can change this selector based on your theme structure
    selectorStr.split(',').forEach((selector) => {
        const selectorTrimmed = selector.trim();
        if (selectorTrimmed) {
            document.querySelectorAll(selectorTrimmed).forEach(modifyLink);
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    setAvailabilityFilterInCollectionLinks();
});

$( ".navmenu-link-depth-1.navmenu-link-parent" ).each(function( index ) {
  var oldURL = $(this).data('href');
  var newURL = oldURL + "?filter.v.availability=1";
  $(this).attr('data-href', newURL);
  
});


$('.collection-filters__filter-title:contains("Tuotetyyppi")').parent().parent().find( ".collection-filters__filter-list-item" ).each(function( index ) {
  if($(this).text().includes('tyyppi')){
    $(this).find(".collection-filters__filter-list-item-text").text(function () {
      return $(this).text().replace("tyyppi_", ""); 
    });
  }

  else{
    $(this).remove();
  }
});

$('.active-filter-group .active-filter-group__item-wrapper').each(function( index ) {
  //console.log($(this));
  if($(this).text().includes('tyyppi')){
    $(this).find(".active-filter-text").text(function () {
      return $(this).text().replace("tyyppi_", ""); 
    });
  }
  
});

$( ".collection-filters__filter-link[data-disabled]" ).each(function( index ) {
  
  $(this).parent().hide();
});




